import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { UiKitModule } from '@serviceplan/ui-kit';
import { ClientEnvironment, ENVIRONMENT, StorageUtilityLib, USER_SESSION_TOKEN, UserData, UserSession, UserSessionService } from '@thehubz/client/core';
import { UserInfo } from '@thehubz/client/data-access-api';
import { brandedLogoUrl } from '@thehubz/shared/branding';

@Component({
  selector: 'wl-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatMenuModule, UiKitModule],
})
export class HeaderComponent implements OnInit {
  loggedInUser?: UserInfo;
  impersonated?: UserInfo;
  logoUrl!: string;
  isJackpotPage = false;

  constructor(
    @Inject(ENVIRONMENT) private env: ClientEnvironment,
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private storageUtility: StorageUtilityLib,
    private router: Router,
    private userSessionService: UserSessionService,
  ) {}

  ngOnInit() {
    const asUserInfo = (userData: UserData) => ({
      id: userData._id,
      name: userData.firstName + ' ' + userData.lastName,
      email: userData.email,
    });

    const userSession = this.storageUtility.getLocalStorageNullable<UserSession>(this.userSessionToken);
    if (userSession) {
      this.loggedInUser = asUserInfo(userSession.userData);
      if (userSession.userData.impersonate) {
        this.impersonated = asUserInfo(userSession.userData.impersonate);
      }
    }
    if (this.router.url.includes('jackpot-assets')) {
      this.isJackpotPage = true;
      this.logoUrl = 'assets/logos/eurojackpot-logo.svg';
    } else {
      this.logoUrl = brandedLogoUrl(this.env.brandingKey);
    }
  }

  logoutUser(impersonated?: boolean) {
    this.userSessionService.logoutUser(impersonated, '/welcome');
  }
}
